import React from 'react'
import styled from 'styled-components';

const FlexContainer = ({
  children,
  flexDirection,
  justifyContent,
  alignItems,
  backgroundColor,
  margin,
  padding,
  width,
  height,
  borderRadius,
  textAlign,
  minHeight,
  boxShadow,
  ...props
}) => {
  return (
    <Wrapper
      {...props}
      flexDirection={flexDirection}
      justifyContent={justifyContent}
      alignItems={alignItems}
      backgroundColor={backgroundColor}
      margin={margin}
      padding={padding}
      width={width}
      height={height}
      borderRadius={borderRadius}
      textAlign={textAlign}
      minHeight={minHeight}
      boxShadow={boxShadow}
    >
      {children}
    </Wrapper>
  )
}

export default FlexContainer;

const Wrapper = styled.div`
    margin:${props => props.margin ? props.margin : '0%'};
    padding: ${props => props.padding ? props.padding : '0px'};
    width: ${props => props.width ? props.width : '100%'};
    height: ${props => props.height ? props.height : '100%'};
    border-radius: ${props => props.borderRadius ? props.borderRadius : '0px'};
    display: flex;
    flex-direction: ${props=> props.flexDirection ? props.flexDirection : 'column'};
    justify-content: ${props=> props.justifyContent ? props.justifyContent : 'center'};
    align-items: ${props=> props.alignItems ? props.alignItems : 'center'};
    background-color: ${props=> props.backgroundColor ? props.backgroundColor: 'var(--color-blanco)'};
    text-align:${props=> props.textAlign ? props.textAlign : 'center'};
    box-sizing:border-box;
    min-height:${props=> props.minHeight ? props.minHeight : 'auto'};
    box-shadow:${props=> props.boxShadow ? props.boxShadow : 'none'};
    
`;

